// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1e4FK","footer":"ModalFilter_footer__3aP2F"};